import { useSelector } from 'react-redux';

import {
  selectCPMFTrackingForecastChartData,
  selectCPMFTrackingForecastChartType,
  selectCPMFTrackingForecastSubpage,
  selectCPMFTrackingForecastAutoQuerying,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import type { MeteorologyFieldsTrackingForecastControlPanelState as T } from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { ResponseError } from 'services/api/base';

export default function useChartData() {
  const subpage: T['subpage'] = useSelector(selectCPMFTrackingForecastSubpage);
  const chartType: T['chartType'] = useSelector(selectCPMFTrackingForecastChartType);
  const chartData: T['chartData'] = useSelector(selectCPMFTrackingForecastChartData);
  // Auto-consulta de abertura em curso (#1822): o slot ainda não tem isFetching,
  // então o gráfico usa esta flag para manter o spinner durante toda a cascata.
  const autoQuerying: T['autoQuerying'] = useSelector(selectCPMFTrackingForecastAutoQuerying);
  const key = `${subpage}-${chartType}`;

  const { data, error, isFetching } = chartData[subpage][chartType];

  return {
    key,
    data,
    isFetching,
    autoQuerying,
    queryError: error as ResponseError | undefined,
  };
}
